import axios from "axios";

const CATEGORY_API_URL = "http://iudi-api.thinkdiff.us/api/categories";

// ✅ Cache categories trong memory
let categoriesCache = null;
let cacheTimestamp = null;
const CACHE_DURATION = 5 * 60 * 1000; // 5 phút

export const fetchAllCategories = async (forceRefresh = false) => {
  try {
    // Kiểm tra cache
    const now = Date.now();
    if (
      !forceRefresh &&
      categoriesCache &&
      cacheTimestamp &&
      now - cacheTimestamp < CACHE_DURATION
    ) {
      console.log("✅ Sử dụng categories từ cache");
      return categoriesCache;
    }

    console.log("🔄 Fetching categories từ API...");
    const response = await axios.get(CATEGORY_API_URL);
    const data = response.data.data || [];

    // Lưu vào cache
    categoriesCache = data;
    cacheTimestamp = now;

    return data;
  } catch (error) {
    console.error("Error fetching categories:", error);

    // Nếu có cache cũ, trả về cache thay vì throw error
    if (categoriesCache) {
      console.log("⚠️ API lỗi, sử dụng cache cũ");
      return categoriesCache;
    }

    throw error;
  }
};

// ✅ Hàm clear cache (dùng khi cần refresh)
export const clearCategoriesCache = () => {
  categoriesCache = null;
  cacheTimestamp = null;
};
